module.exports = __webpack_public_path__ + "fonts/fa-solid-900.f3a7d3b.woff";